import req from './api'

export const apiGetTenants = () => req("get", "/tenants/?group=admin");


